module.exports = __webpack_public_path__ + "static/img/blog_good_12.0a6bb8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_good_12.png
// module id = 5ggc
// module chunks = 8